module.exports = __webpack_public_path__ + "img/extended.93c4c833.png";